import { useMutation } from '@tanstack/react-query';
import { updateAllTasksCollapsedLifeAreas } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateAllTasksCollapsedLifeAreasMutation = () =>
  useMutation({
    mutationFn: async (newOrder: ID[]) =>
      updateAllTasksCollapsedLifeAreas(newOrder),
  });
